var map = {
	"./all.png": 5579,
	"./blur.png": 5311,
	"./clipart.png": 8167,
	"./doodle.png": 5819,
	"./filters.png": 1427,
	"./logo.png": 4265,
	"./onTheSpotPrecheck.png": 3243,
	"./smc.png": 3657,
	"./standard.png": 6015,
	"./text.png": 8173,
	"./theme.png": 8113,
	"./vertical.png": 6886
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7338;